export const CLIENT_BACKGROUND_COLOR = '#eaffea';

export const typeUser = {
	Admin: 'Admin',
	Client: 'Client',
};

export const statuses = {
	unread: 'unread',
	read: 'read',
};

export const feedbackStatuses = [
	{ id: statuses.unread, name: 'нет' },
	{ id: statuses.read, name: 'да' },
];
